import { render } from "./ConfigManager.vue?vue&type=template&id=23619248&scoped=true&ts=true"
import script from "./ConfigManager.vue?vue&type=script&lang=ts"
export * from "./ConfigManager.vue?vue&type=script&lang=ts"

import "./ConfigManager.vue?vue&type=style&index=0&id=23619248&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23619248"]])

export default __exports__